import { formatMoney } from 'common/services/format'
import { ProcedureSelect } from './components/procedure-select'
import { ProcedureActions } from './components/procedure-actions/procedure-actions'
import type { ColumnsType } from 'antd/es/table'

import type { ProcedureItem } from 'features/Procedure/state/procedure-api.type'
import styles from './treatments.module.scss'

type ColumnsParams = {
  onEditProcedure: (procedure: ProcedureItem) => void
  onScanProducts: (procedure: ProcedureItem) => void
  onNavigateToForms?: (documentId?: number | null) => void
}

export const getTreatmentsTableColumns = ({
  onEditProcedure,
  onScanProducts,
  onNavigateToForms,
}: ColumnsParams): ColumnsType<ProcedureItem> => [
  {
    title: 'Diagnosis',
    dataIndex: 'justify_codes',
    key: 'justify_codes',
    render: (_: string, item: ProcedureItem, index: number) => {
      return <ProcedureSelect procedure={item} index={index} onEditProcedure={onEditProcedure} />
    },
  },
  ...baseColumns(onEditProcedure),
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    fixed: 'right' as const,
    render: (_: string, item: ProcedureItem) => {
      return (
        <ProcedureActions
          procedure={item}
          onScanProducts={onScanProducts}
          onNavigateToForms={onNavigateToForms}
        />
      )
    },
  },
]

export const baseColumns = (onEditProcedure?: (procedure: ProcedureItem) => void) => [
  {
    title: 'Procedure',
    dataIndex: 'code_text',
    key: 'code_text',
    render: (text: string, item: ProcedureItem) => {
      if (onEditProcedure) {
        return (
          <button onClick={() => onEditProcedure(item)} className={styles.procedureLink}>
            {text || '-'}
          </button>
        )
      }
      return text || '-'
    },
  },
  // {
  //   title: 'CPT',
  //   dataIndex: 'code',
  //   key: 'code',
  // },

  {
    title: 'Units',
    dataIndex: 'procedure_units',
    key: 'procedure_units',
    render: (units: string) => {
      if (!units) return '-'
      const num = parseFloat(units)
      return Number.isNaN(num) ? units : (Math.round(num * 100) / 100).toFixed(2)
    },
  },
  {
    title: 'Qty',
    dataIndex: 'units',
    key: 'units',
    render: (units: number) => units ?? '-',
  },
  {
    title: 'Price',
    dataIndex: 'fee',
    key: 'fee',
    render: (fee: number) => (fee != null ? formatMoney(fee) : '-'),
  },
  {
    title: 'Discount',
    dataIndex: 'discount_amount',
    key: 'discount_amount',
    render: (discount_amount: number | undefined) => {
      if (!discount_amount) return '-'
      return formatMoney(discount_amount)
    },
  },
  {
    title: 'Total',
    dataIndex: 'total_price',
    key: 'total_price',
    render: (total_price: number) => (total_price != null ? formatMoney(total_price) : '-'),
  },
]
